import {Injectable} from "@angular/core";
import {BehaviorSubject, tap} from "rxjs";
import {AuthenticationService} from "./authentication-service";
import {AccountService} from "./api/account.service";


@Injectable({providedIn: "root"})
export class SessionService {

  _displayName: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private authService: AuthenticationService,
    private accountService: AccountService
  ) {
  }

  getDisplayName() {

    if (this.authService.isAuthenticated() && !this._displayName.value) {
      const tokenUser = this.authService._user.value
      this._displayName.next(tokenUser?.name)

      this.accountService.getAccountById(tokenUser?.id, {'simple': true}).pipe(
        tap({
          next: (response) => {
            const name = response.data.firstname + " " + response.data.lastname
            this._displayName.next(name)
          }
        })
      ).subscribe()
    }
  }

}
